(() => {
  const roots = document.querySelectorAll('.mb-main-product');

  roots.forEach((root) => {
    const sectionId = root.dataset.section;
    const fixedButton = root.querySelector('.mb-mobile-fixed-atc');
    const productForm = root.querySelector(`#product-form-${sectionId}`);

    if (!fixedButton || !productForm) return;

    const label = fixedButton.querySelector('span');
    const spinner = fixedButton.querySelector('.loading__spinner');
    let loadingTimer;

    const setLoading = (isLoading) => {
      window.clearTimeout(loadingTimer);
      fixedButton.classList.toggle('loading', isLoading);
      fixedButton.setAttribute('aria-busy', String(isLoading));
      spinner?.classList.toggle('hidden', !isLoading);

      if (isLoading) {
        loadingTimer = window.setTimeout(() => setLoading(false), 12000);
      }
    };

    const syncFromNativeButton = (nativeButton) => {
      if (!nativeButton) return;

      const isDisabled = nativeButton.hasAttribute('disabled') || nativeButton.getAttribute('aria-disabled') === 'true';
      const nativeLabel = nativeButton.querySelector('span:not(.sold-out-message)')?.textContent?.trim();
      fixedButton.disabled = isDisabled;
      fixedButton.setAttribute('aria-disabled', String(isDisabled));

      if (label && nativeLabel) label.textContent = nativeLabel;
    };

    syncFromNativeButton(root.querySelector(`#ProductSubmitButton-${sectionId}`));

    productForm.addEventListener('submit', () => {
      if (!fixedButton.disabled) setLoading(true);
    });

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (String(data?.sectionId) !== String(sectionId)) return;

      const nativeButton = data.html?.getElementById(`ProductSubmitButton-${data.sectionId}`);
      syncFromNativeButton(nativeButton);

      if (!data.variant && label) {
        label.textContent = window.variantStrings?.unavailable || 'Unavailable';
      }
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source }) => {
      if (source === 'product-form') setLoading(false);
    });

    subscribe(PUB_SUB_EVENTS.cartError, ({ source }) => {
      if (source === 'product-form') setLoading(false);
    });
  });
})();
